import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApiURL from "../controllers/Api";
import EmployeeLayout from "./EmployeeLayout";

const cardClass =
  "rounded-2xl border border-gray-200 bg-white p-6 shadow-sm hover:shadow-md transition-shadow";

const getCurrentUserId = () => {
  try {
    const raw = localStorage.getItem("user");
    const user = raw ? JSON.parse(raw) : null;
    return user?.id || 1;
  } catch {
    return 1;
  }
};

export default function EmployeeHome() {
  const [summary, setSummary] = useState(null);
  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch {
      return {};
    }
  })();

  useEffect(() => {
    const loadSummary = async () => {
      const query = new URLSearchParams({ period: "today", user_id: String(getCurrentUserId()) }).toString();
      const response = await fetch(`${ApiURL}crm/employee/get_dashboard_summary.php?${query}`);
      const result = await response.json().catch(() => ({}));
      setSummary(result?.data || null);
    };
    loadSummary();
  }, []);

  return (
    <EmployeeLayout
      title="Recruiter Dashboard"
      description="See your assigned resumes, pipeline movement, and follow-up work."
    >
      <div className="mx-auto max-w-6xl space-y-8">
        <div>
          <h1 className="text-3xl font-bold text-slate-900">Recruiter Dashboard</h1>
          <p className="mt-2 text-sm text-slate-600">See your assigned resumes, pipeline movement, and follow-up work.</p>
        </div>
        <div className="grid gap-6 md:grid-cols-3">
          <div className={cardClass}><div className="text-sm text-slate-500">Assigned Resumes</div><div className="mt-2 text-3xl font-bold text-slate-900">{summary?.leads?.total_assigned || 0}</div></div>
          <div className={cardClass}><div className="text-sm text-slate-500">Hired</div><div className="mt-2 text-3xl font-bold text-slate-900">{summary?.leads?.converted_count || 0}</div></div>
          <div className={cardClass}><div className="text-sm text-slate-500">Pending Follow-ups</div><div className="mt-2 text-3xl font-bold text-slate-900">{summary?.follow_ups?.pending || 0}</div></div>
        </div>
        <div className="grid gap-6 md:grid-cols-2">
          {user?.can_view_resume_library ? (
            <Link to="/employee/resume-library" className={cardClass}>
              <div className="text-lg font-semibold text-slate-900">Resume Library</div>
              <p className="mt-2 text-sm text-slate-600">View company resumes, tag them to clients, and assign recruiters.</p>
            </Link>
          ) : null}
          {user?.can_manage_sub_companies ? (
            <Link to="/employee/sub-companies" className={cardClass}>
              <div className="text-lg font-semibold text-slate-900">Sub Companies</div>
              <p className="mt-2 text-sm text-slate-600">Manage client companies, requirements, and related resume tags.</p>
            </Link>
          ) : null}
          {user?.can_upload_resumes === false ? null : (
            <Link to="/employee/upload-resumes" className={cardClass}>
              <div className="text-lg font-semibold text-slate-900">Upload Resumes</div>
              <p className="mt-2 text-sm text-slate-600">Add candidates directly into your company resume pool.</p>
            </Link>
          )}
          {user?.can_post_jobs ? (
            <Link to="/employee/jobs" className={cardClass}>
              <div className="text-lg font-semibold text-slate-900">Post Job</div>
              <p className="mt-2 text-sm text-slate-600">Publish roles under your company account.</p>
            </Link>
          ) : null}
          <Link to="/employee-lead-report" className={cardClass}>
            <div className="text-lg font-semibold text-slate-900">Assigned Resumes</div>
            <p className="mt-2 text-sm text-slate-600">Open the list of resumes currently assigned to you.</p>
          </Link>
          <Link to="/follow-up" className={cardClass}>
            <div className="text-lg font-semibold text-slate-900">Follow-up Report</div>
            <p className="mt-2 text-sm text-slate-600">Review all follow-up entries linked to your work.</p>
          </Link>
        </div>
      </div>
    </EmployeeLayout>
  );
}
